import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AddressDetails } from 'src/app/models/onboarding/applicant-address.model';
import {
	ApplicantData,
	AuthorizedCreditDetails,
	PreApplicationCreditData,
	PreApplicationState,
	Product,
	SimulatorData,
} from 'src/app/models/state/pre-application.model';

export const PreApplicationActions = createActionGroup({
	source: 'PreApplication',
	events: {
		'Add PreApplicationId': props<{ preApplicationId: number }>(),
		'Add Applicant Data': props<ApplicantData>(),
		'Add Applicant Contact Data': props<{
			applicantPhone: string;
			email: string;
		}>(),
		'Add PreApplicaton Credit Data': props<PreApplicationCreditData>(),
		'Add Product Cobis Id': props<{ productCobisId: string }>(),
		'Reset PreApplication': emptyProps(),
		'Add subProductId': props<{ subProductId: number }>(),
		'Add Data From Simulator': props<SimulatorData>(),
		'Add Authorized Credit Details': props<AuthorizedCreditDetails>(),
		'Add OTP Code': props<{ otpCode: string }>(),
		'Add Application Id': props<{ applicationId: number }>(),
		'Add Applicant Id For New Leads': props<{ applicantId: number }>(),
		'Load Pre Application Data From Digital Process':
			props<PreApplicationState>(),
		'Add Product Data': props<Product>(),
		'Add Social Contribution Application And Schoolarship Info': props<{
			isSocialContributionApplicable: boolean;
			schoolarshipCertificateId: number;
		}>(),
		'Add Amount From Investement Simulator': props<{ amount: number }>(),
		'Add Product And SubProduct': props<{
			productId: number;
			subProductId: number;
		}>(),
		'Add Applicant Addresses': props<{ addresses: Array<AddressDetails> }>(),
	},
});
